import React, { CSSProperties, FC } from 'react';
import { Typography, TypographyProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  text: {
    fontWeight: 'bold',
    fontStyle: 'normal',
    lineHeight: '266%',
    fontSize: 12,
    fontFamily: 'Futura PT',
    textTransform: 'uppercase',
    color: '#A568F3',
    letterSpacing: '1px',
    marginTop: '50px',
  },
}));

interface Props {
  text: string | React.ReactElement;
  className?: CSSProperties;
}

export const SubtitleOfSection: FC<Props & TypographyProps> = ({
  text,
  className,
  ...props
}) => {
  const { classes, cx } = useStyles();

  return (
    <Typography
      variant="h3"
      className={cx(classes.text, className)}
      {...props}
    >
      {text}
    </Typography>
  );
};
